import Styles from "./UserProfile.module.css";
import { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CompanyDetails from "./CompanyDetails/CompanyDetails";
import ConsumerDetails from "./ConsumerDetails/ConsumerDetails";
import GeneratorDetails from "./GeneratorDetails/GeneratorDetails";
import BankingDetails from "./BankingDetails/BankingDetails";
import { useSelector, useDispatch } from "react-redux";
import { fetchCompanyDetails } from "../../Redux/Slices/profileSlice";
import {
  fetchConsumers,
  fetchGenerators,
  fetchDiscoms,
} from "../../Redux/Slices/companyAdminSlice";
import {
  fetchSideBarConsumerList as fetchConsumerListAction,
  fetchSideBarGeneratorsList as fetchGeneratorListAction,
} from "../../Redux/Slices/CapacitySlice";

const getActiveList = (userType) => {
  const baseList = [
    {
      id: "companyInfo",
      name: "Company Details",
      component: <CompanyDetails />,
    },
  ];

  if (
    userType === "Consumer" ||
    userType === "Prosumer" ||
    userType === "Discom"
  ) {
    baseList.push({
      id: "consumer",
      name: "Consumer Details",
      component: <ConsumerDetails />,
    });
  }

  if (
    userType === "Generator" ||
    userType === "Prosumer" ||
    userType === "Discom"
  ) {
    baseList.push({
      id: "generator",
      name: "Generator Details",
      component: <GeneratorDetails />,
    });
  }

  if (userType === "Discom") {
    baseList.push({
      id: "banking",
      name: "Discom Details",
      component: <BankingDetails />,
    });
  }

  return baseList;
};

const UserProfile = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("companyInfo");

  const handleBackClick = () => {
    window.history.back();
  };

  const renderActiveComponent = () => {
    const activeList = getActiveList(userType);
    const activeItem = activeList.find((item) => item.id === activeTab);
    return activeItem ? activeItem.component : null;
  };

  const { discoms } = useSelector((state) => state.companyAdminSlice);
  const { fetchSideBarConsumerList, fetchSideBarGeneratorsList } = useSelector(
    (state) => state.CapacitySlice
  );

  const userType =
    discoms?.length > 0
      ? "Discom"
      : fetchSideBarConsumerList?.length > 0 &&
          fetchSideBarGeneratorsList?.length > 0
        ? "Prosumer"
        : fetchSideBarConsumerList?.length > 0
          ? "Consumer"
          : fetchSideBarGeneratorsList?.length > 0
            ? "Generator"
            : "NA";

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);

    if (tabId === "consumer") {
      dispatch(fetchConsumerListAction());
    } else if (tabId === "generator") {
      dispatch(fetchGeneratorListAction());
    } else if (tabId === "banking") {
      dispatch(fetchDiscoms());
    }
  };

  const userData = useSelector((state) => state.persistedReducer);

  useEffect(() => {
    // if (companyId) {
    //   dispatch(fetchCompanyDetails(companyId));
    // }
    dispatch(fetchCompanyDetails());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchConsumerListAction());
    dispatch(fetchGeneratorListAction());
    dispatch(fetchDiscoms());
  }, [dispatch]);

  return (
    <div className={Styles.userCompany}>
      <div className={Styles.companyNameContainer}>
        <ArrowBackIcon
          onClick={handleBackClick}
          style={{
            cursor: "pointer",
            width: "20px",
            height: "20px",
            paddingLeft: "5px",
          }}
        />
        <span>
          {/* {companyDetails?.companyName ||
            userData?.company?.companyName ||
            "Member Company Name"} */}
          Member Company Name
        </span>
      </div>
      <div className={Styles.detailsContainer}>
        <div className={Styles.SwitchNavContainer}>
          {getActiveList(userType).map((item) => (
            <div
              key={item.id}
              className={`${Styles.tabdiv} ${
                activeTab === item.id ? Styles.tabdivActive : ""
              }`}
              onClick={() => handleTabClick(item.id)}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className={Styles.tabContent}>{renderActiveComponent()}</div>
      </div>
    </div>
  );
};

export default UserProfile;
